import {
  collection,
  query,
  where,
  getDocs,
} from 'firebase/firestore';
import { FirestoreCollections, firestore } from '../../../firebase.config';
import Subscription from '../../models/Subscription';
import Failure from '../../../core/Failure';

type GetSubscriptionsByPlanIdResponse = {
  subscriptions: Subscription[];
};

async function getSubscriptionsByPlanId(
  planId: string,
): Promise<GetSubscriptionsByPlanIdResponse | null> {
  try {
    const db = firestore;
    const subscriptionsCollection = collection(db, FirestoreCollections.subscriptions);

    const subscriptionsQuery = query(subscriptionsCollection, where('id_plan', '==', planId));
    const subscriptionsSnapshot = await getDocs(subscriptionsQuery);

    const subscriptions: Subscription[] = [];

    subscriptionsSnapshot.docs.forEach((doc) => {
      subscriptions.push(Subscription.fromFirestore(doc));
    });

    return {
      subscriptions,
    };
  } catch (e) {
    console.log('error: ', e);
    throw new GetSubscriptionsByPlanIdFailure();
  }
}

export class GetSubscriptionsByPlanIdFailure extends Failure {
  constructor(message = 'Unknown error', code = 'unknown-error') {
    super(message, code);
  }
}

export default getSubscriptionsByPlanId;